import { getEndpoint } from "../endpoints";

import {
	httpServiceInstance,
	type HttpService,
} from "./http.service";

export type TRealtimeTicket = {
	token: string;
	channels: Array<string>;
};

const REALTIME_STREAM_URL =
	"https://stream.alloan.ai/realtime/stream";

export class RealtimeService {
	private static http: HttpService;
	private static endpoint: string;

	constructor() {
		RealtimeService.http = httpServiceInstance;
		RealtimeService.endpoint = getEndpoint();
	}

	public createTicket = async (
		channels: Array<string>
	): Promise<TRealtimeTicket> => {
		const url = `${RealtimeService.endpoint}/api/realtime/ticket`;
		const { data } =
			await RealtimeService.http.post<TRealtimeTicket>(url, {
				data: { channels },
			});
		return data;
	};

	public getStreamUrl = (token: string): string => {
		return `${REALTIME_STREAM_URL}?token=${encodeURIComponent(token)}`;
	};
}
